<template>
  <el-dialog title="店铺授权过期提醒" :visible="visible" width="1000px" top="5vh" append-to-body :close-on-click-modal="false"
    :show-close="false" class="auth-expire-reminder">
    <div class="reminder-content">
      <div class="reminder-icon">
        <i class="el-icon-warning"></i>
      </div>
      <div class="reminder-text">您有 {{ expireList.length }} 个店铺授权即将过期或已过期，请及时处理！</div>
      <el-table :data="expireList" border style="width: 100%" class="reminder-table">
        <el-table-column prop="title" align="center" label="店铺名称" min-width="160" show-overflow-tooltip>
          <template slot-scope="scope">
            <div class="shop-info">
              <img v-if="scope.row.shopLogo" :src="scope.row.shopLogo" class="shop-logo" />
              <span class="shop-name">{{ scope.row.title }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="source" align="center" label="平台" width="90">
          <template slot-scope="scope">
            <span>{{ scope.row.source === 'tb' ? '淘宝' : scope.row.source === '1688' ? '1688' : scope.row.source
            }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="authEndTime" align="center" label="授权到期时间" min-width="180">
        </el-table-column>
        <el-table-column prop="remainingDays" align="center" label="剩余天数" width="110">
          <template slot-scope="scope">
            <span :style="{ color: scope.row.remainingDays < 0 ? '#f56c6c' : '#e6a23c', fontWeight: '600' }">
              {{ scope.row.remainingDays < 0 ? '已过期' + Math.abs(scope.row.remainingDays) + '天' : '剩余' +
                scope.row.remainingDays + '天' }} </span>
          </template>
        </el-table-column>
        <el-table-column prop="expirationType" align="center" label="到期类型" width="130">
          <template slot-scope="scope">
            <el-tag :type="getExpirationTypeTag(scope.row.expirationType)" size="mini">
              {{ getExpirationTypeText(scope.row.expirationType) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作" width="200">
          <template slot-scope="scope">
            <el-button type="primary" size="mini" @click="handleAuth(scope.row)">
              去授权
            </el-button>
            <el-button type="success" size="mini" @click="handleSubscribe(scope.row)">
              去订阅
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">我知道了</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { getShopAuthUrl } from "@/api/login.js";
export default {
  name: 'AuthExpireReminder',
  data() {
    return {
      visible: false,
      expireList: []
    };
  },
  methods: {
    open(data) {
      this.expireList = data || [];
      if (this.expireList.length > 0) {
        this.visible = true;
      }
    },
    handleClose() {
      this.visible = false;
    },
    handleGoToShop() {
      this.visible = false;
      this.$router.push('/shop/purchaseShopList');
    },
    handleAuth(row) {
      getShopAuthUrl({
        callback: "login",
        type: row.source,
      }).then((res) => {
        if (res.data.code == 200) {
          window.open(`${res.data.data}`);
        }
      });
    },
    handleSubscribe(row) {
      window.open("https://fuwu.taobao.com/ser/detail.htm?service_code=ts-26066");
    },
    getExpirationTypeTag(type) {
      const typeMap = {
        'EXPIRED_AND_EXPIRING': 'danger',
        'EXPIRED': 'danger',
        'EXPIRING_SOON': 'warning'
      };
      return typeMap[type] || 'info';
    },
    getExpirationTypeText(type) {
      const typeMap = {
        'EXPIRED_AND_EXPIRING': '已过期+即将过期',
        'EXPIRED': '已失效',
        'EXPIRING_SOON': '快过期'
      };
      return typeMap[type] || type;
    }
  }
};
</script>

<style lang="less" scoped>
.reminder-content {
  text-align: center;
}

.reminder-icon {
  margin-bottom: 10px;

  i {
    font-size: 48px;
    color: #e6a23c;
  }
}

.reminder-text {
  font-size: 14px;
  color: #606266;
  margin-bottom: 15px;
}

.reminder-table {
  font-size: 12px;
}

.shop-info {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;

  .shop-logo {
    width: 24px;
    height: 24px;
    border-radius: 4px;
  }

  .shop-name {
    max-width: 120px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

.dialog-footer {
  display: flex;
  justify-content: center;
}
</style>